/* eslint-disable */
// src/examples/Breadcrumbs/breadcrumbs.routes.js

export const breadcrumbRoutes = [
  { route: "/dashboard", name: "Inicio" },
  { route: "/security", name: "Seguridad" },
  { route: "/authorized-device-status", name: "Solicitud de acceso" },

  { route: "/person", name: "Clientes" },
  { route: "/client/inactive", name: "Clientes Inactivos", parent: "/person" },

  { route: "/machine", name: "Máquinas" },
  { route: "/machine/eliminated", name: "Máquinas eliminadas", parent: "/machine" },

  { route: "/local", name: "Locales" },
  { route: "/local/inactive", name: "Locales Inactivos", parent: "/local" },

  { route: "/machineType", name: "Tipos de máquina" },

  { route: "/localDeposito", name: "Depósitos" },
  { route: "/localDesechos", name: "Bajas", parent: "/localDeposito" },

  { route: "/allVisitTransactions", name: "Ingresos general" },

  { route: "/local/:id", name: ({ params }) => `Local ${params.id}` },
  { route: "/local/:id/visitMachine", hide: true },
  {
    route: "/local/:id/visitMachine/nuevo",
    parent: "/local/:id/recaudaciones/tragamonedas",
    name: ({ params }) => {
      try {
        const cached = sessionStorage.getItem(`bc:visitDraft:${params.id}`);
        return cached ? `Alta de recaudación ${cached}` : "Alta de recaudación";
      } catch {
        return "Alta de recaudación";
      }
    },
  },
  {
    route: "/local/:id/visitMachine/:visitId/editar",
    name: ({ params }) => `Editar Recaudación ${params.visitId}`,
    parent: ({ params }) => `/local/${params.id}/recaudaciones/tragamonedas`,
  },

  {
    route: "/local/:id/recaudaciones",
    name: "Ingresos",
    parent: ({ params }) => `/local/${params.id}`,
  },
  {
    route: "/local/:id/recaudaciones/tragamonedas",
    name: "Recaudaciones",
    parent: ({ params }) => `/local/${params.id}`,
  },
  {
    route: "/local/:id/recaudaciones/:visitId",
    name: ({ params }) => `Detalle ${params.visitId}`,
    parent: "/local/:id/recaudaciones/tragamonedas",
  },

  { route: "/visit-details/:id", name: "Detalle de recaudación" },
];
